import { DEFAULT_INVALID_DROPTYPE } from 'pages/Drops/constants'
import { useParams } from 'react-router-dom'

export const useDropTypeFromPath = () => {
  const params = useParams<{ droptype?: string }>()
  return params?.droptype ?? DEFAULT_INVALID_DROPTYPE
}
